// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatIndicator_wrapper__24eX9","hasIndicator":"ChatIndicator_hasIndicator__2z0HB"};